import React from 'react';
import PropTypes from 'prop-types';

import { StyledSelect } from './SelectStyles';
import { renderDefaultMessageOnSelect } from '../../Utils/VariantUtils';
import SelectOption from './SelectOption';
var Select = function Select(props) {
  var defaultMessage = renderDefaultMessageOnSelect(props.option.name);
  return React.createElement(
    StyledSelect,
    {
      onChange: props.handleOptionChange,
      name: props.option.name,
      key: props.option.name,
      value: props.selectedOption[0].value,
      defaultValue: 'DEFAULT'
    },
    React.createElement(
      'option',
      { disabled: true, value: 'DEFAULT' },
      defaultMessage
    ),
    props.option.values.map(function (value) {
      return React.createElement(
        SelectOption,
        {
          key: props.option.name + '-' + value,
          value: value,
          selectedOptions: props.selectedOptions,
          name: props.option.name,
          variants: props.variants
        },
        value + '$'
      );
    })
  );
};

Select.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
  selectedOption: PropTypes.string,
  selectedOptions: PropTypes.object,
  variants: PropTypes.array
};

export default React.memo(Select);